import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = "Loading...", 
  fullScreen = false 
}) => {
  const containerClass = fullScreen 
    ? "fixed inset-0 bg-brand-bg/80 backdrop-blur-sm z-50 flex items-center justify-center"
    : "flex items-center justify-center h-64";

  return (
    <div className={containerClass}>
      <div className="flex flex-col items-center space-y-4">
        <div className="w-12 h-12 border-4 border-brand-primary border-t-transparent rounded-full animate-spin"></div>
        <p className="text-brand-text-secondary font-medium">{message}</p>
      </div>
    </div>
  );
};